import { useAppEnvironmentStore } from '../../../stores/AppEnvironment/appEnvironment.store';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useOrderContext } from '../contexts/Order.context';
import { StatusType } from '../order.types';
import { getOrderView } from '../ordersView.utils';

const useOrderView = () => {
  const { order, canEditOrder } = useOrderContext();
  const { userRole, team } = useApplicationContext();
  const appEnvironment = useAppEnvironmentStore((state) => state.appEnvironment);

  return getOrderView({
    canEditOrder,
    appEnvironment,
    role: userRole,
    integrations: team?.brand?.integrations,
    orderStatus: order?.status as StatusType | undefined,
    orderIntegrationStatus: order?.synchronized,
  });
};

export default useOrderView;
